import React, {Component} from "react";
import TopNav from "../../../common/nav/TopNav";
import Footer from "../../../common/Footer";
import PageBlock from "../../../common/PageBlock";
import {currentSiteName} from "../../../service/SiteService";

class Contact extends Component {
    render() {
        return (
            <div>
                <TopNav tab="docs"/>

                <PageBlock>
                    <div className="container">

                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="page-header">Contact us</h1>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <h3>Drop us a line</h3>
                                <p>
                                    If you have any questions, queries or suggestions about {currentSiteName}, please feel free to contact us.
                                </p>
                                <p>
                                    You can reach our friendly team of humans at <a href="mailto:info@gatehillsoftware.com">info@gatehillsoftware.com</a>
                                </p>

                                <h3>Other products</h3>
                                <p>
                                    If you’d like to learn more about our other products and services,
                                    find us at <a href="https://www.gatehill.io">gatehill.io</a>.
                                </p>
                            </div>
                        </div>

                    </div>
                </PageBlock>

                <Footer />
            </div>
        );
    }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/modules/views/docs/about/Contact.js